const MOBILE_APP_SCHEME = "joi.pho";
export const isNativeAppShareHandoffEnabled =
  import.meta.env.VITE_ENABLE_NATIVE_APP_SHARE_HANDOFF === "true";

export type MobilePlatform = "ios" | "android" | "desktop";

interface BrowserShareUrlOptions {
  baseUrl: string;
  ownerId: string;
  albumId: string;
  token: string;
  openInBrowser?: boolean;
}

interface MobileAppShareUrlOptions {
  platform: Exclude<MobilePlatform, "desktop">;
  ownerId: string;
  albumId: string;
  token: string;
  webFallbackUrl: string;
}

export function getMobilePlatform(userAgent?: string): MobilePlatform {
  if (typeof navigator === "undefined" && !userAgent) {
    return "desktop";
  }

  const resolvedUserAgent = (userAgent || navigator.userAgent).toLowerCase();

  if (/iphone|ipad|ipod/.test(resolvedUserAgent)) {
    return "ios";
  }

  if (/android/.test(resolvedUserAgent)) {
    return "android";
  }

  return "desktop";
}

export function buildBrowserShareUrl({
  baseUrl,
  ownerId,
  albumId,
  token,
  openInBrowser = false,
}: BrowserShareUrlOptions): string {
  const url = new URL(`/owners/${ownerId}/albums/${albumId}/link`, baseUrl);
  url.searchParams.set("token", token);

  if (openInBrowser) {
    url.searchParams.set("openInBrowser", "1");
  }

  return url.toString();
}

export function buildMobileAppShareUrl({
  platform,
  ownerId,
  albumId,
  token,
  webFallbackUrl,
}: MobileAppShareUrlOptions): string {
  const params = new URLSearchParams({
    ownerId,
    albumId,
    token,
    webFallback: webFallbackUrl,
  });

  if (platform === "android") {
    return `intent://share/album?${params.toString()}#Intent;scheme=${MOBILE_APP_SCHEME};S.browser_fallback_url=${encodeURIComponent(webFallbackUrl)};end`;
  }

  return `${MOBILE_APP_SCHEME}://share/album?${params.toString()}`;
}

export function getStoreUrl(platform: MobilePlatform): string | null {
  if (platform === "ios") {
    return import.meta.env.VITE_IOS_APP_STORE_URL || null;
  }

  if (platform === "android") {
    return import.meta.env.VITE_ANDROID_PLAY_STORE_URL || null;
  }

  return null;
}
